import React from "react";
import StatusGenerator from "../StatusGenerator/StatusGenerator";
import SAEDLOGO from "../../Assets/Logo/logo.png";
import moment from "moment";
import "../../Styles/GlobalStyles/printlayout.css";

const PrintLoanStatusFormat = ({ data }) => {
  const watermarkImg = {
    backgroundImage: `url(${SAEDLOGO})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    opacity: "0.03",
    width: "50%",
    height: "auto",
    position: "absolute",
    top: "25%",
    left: "25%",
  };
  const nyscsaedlogoimg = {
    height: "70px",
    width: "auto",
  };
  const table = {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",

    "& td, thead": {
      border: "none",
      textAlign: "left",
      padding: "8px",
    },
  };
  const tdStyle = {
    padding: "10px 10px",
  };
  const trStyle = {
    backgroundColor: "none",
    borderbottom: "1px solid #e2e3e4",
  };
  const theadStyle = {
    color: "#05004E",
    fontWeight: 600,
  };
  const letterHeadSection = {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    padding: "20px 0px",
  };
  const saedText = {
    color: "#F0B811",
  };
  const h2Style = {
    color: "#141213",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "bolder",
    fontSize: "20px",
  };
  const divider = {
    background: "#161616",
    width: "100vw",
    margin: "0px 10px",
  };
  const footerSpacer = {
    width: "100%",
    display: "block",
    height: "calc(20mm + 34px)",
  };
  const footer = {
    position: "fixed",
    bottom: 0,
    textAlign: "center",
    color: "white",
    width: "100%",
    padding: "30px",
    background: "#016C34 !important",
    WebkitPrintColorAdjust: "exact",
    height: "calc(20mm + 34px)",
  };

  return (
    <div>
      <div style={letterHeadSection}>
        <div>
          <img style={nyscsaedlogoimg} src={SAEDLOGO} alt="SAED LOGO" />
        </div>
        <div className="text-section">
          <h2 style={h2Style}>
            NYSC <span style={saedText}>SAED</span>
          </h2>
          <h2> Training Centers Report </h2>
        </div>
      </div>
      <hr style={divider} />
      <br />
      <br />
      <div className="watermark">
        <img style={watermarkImg} src={SAEDLOGO} alt="SAED LOGO" />
      </div>
      <div id="content">
        <table style={table}>
          <thead style={theadStyle}>
            <tr style={trStyle}>
              <td style={tdStyle}>Training Center Name</td>
              <td style={tdStyle}>State</td>
              <td style={tdStyle}>LGA</td>
              <td style={tdStyle}>Skill Set</td>
              <td style={tdStyle}>E-mail Address</td>
              <td style={tdStyle}>Approval Status</td>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              const trainerSkillset = item.skills
                .reduce((acc, cur) => acc + `${cur.name}, `, "")
                .slice(0, -2); // remove trailing space + comma

              return (
                <tr key={index} style={trStyle}>
                  <td style={tdStyle}>{item.skillCenterName}</td>
                  <td style={tdStyle}>{item.state}</td>
                  <td style={tdStyle}>{item.lga}</td>
                  <td style={tdStyle}>{trainerSkillset}</td>
                  <td style={tdStyle}>{item.centerEmail}</td>
                  <td style={tdStyle}>
                    {item.approvalStatus}
                    {/* <GenerateStatus status={item.approvalStatus} /> */}
                    {/* <StatusGenerator statusText="Submitted" variant="yellowFilled" /> */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="footerPrint" style={footerSpacer}></div>
      <footer className="footerPrint" style={footer}>
        <p>
          Plot 416, Tigris Cresent Off Aguiyi Ironsi Street, Maitama.PMB 138,
          Garki ,Abuja.
        </p>
        <p>Email: info@nysc.gov.ng </p>
      </footer>
    </div>
  );
};

export default PrintLoanStatusFormat;

const GenerateStatus = (status) => {
  switch (status) {
    case "Submitted":
      return <StatusGenerator statusText="Submitted" variant="yellowFilled" />;
    case "StateOfficerApproved":
      return (
        <StatusGenerator
          statusText="State Officer Approved"
          variant="greenFilled"
        />
      );
    case "StateOfficerRejected":
      return (
        <StatusGenerator
          statusText="State Officer Disapproved"
          variant="redFilled"
        />
      );
    case "StateCordinatorApproved":
      return (
        <StatusGenerator
          statusText="State Cord. Approved"
          variant="greenFilled"
        />
      );
    case "StateCordinatorRejected":
      return (
        <StatusGenerator
          statusText="State Cord. Disapproved"
          variant="redFilled"
        />
      );
    case "HeadQuatersApproved":
      return <StatusGenerator statusText="HQ Approved" variant="greenFilled" />;
    case "HeadQuatersRejected":
      return (
        <StatusGenerator statusText="HQ Disapproved" variant="redFilled" />
      );
    case "PhysicalVerificationApproved":
      return (
        <StatusGenerator
          statusText="Physical Ver. Approved"
          variant="greenFilled"
        />
      );
    case "PhysicalVerificationRejected":
      return (
        <StatusGenerator
          statusText="Physical Ver. Disapproved"
          variant="redFilled"
        />
      );
    default:
      return "";
  }
};
